import cx from 'classnames';
import { t } from 'i18next';
import type { TProgressBadgeProps } from './types';

export function ProgressBadge(props: TProgressBadgeProps) {
  if (!props.visible) {
    return <span />;
  }

  if (props.hideBadge) {
    return (
      <span title={props.title}>
        {props.numDefeated}/{props.totalBosses}
        &nbsp;
        {t(`common:difficulty.${props.difficulty}.abbreviation`)}
      </span>
    );
  }

  return (
    <span
      className={cx(
        'slds-badge rio-badge rio-border--light rio-shadow--small rio-text-shadow--normal',
        props.size ? `rio-badge-size--${props.size}` : '',
        props.color ? `rio-badge-color--${props.color}` : ''
      )}
      title={props.title}
    >
      {props.numDefeated}/{props.totalBosses}
      &nbsp;
      {t(`common:difficulty.${props.difficulty}.abbreviation`)}
    </span>
  );
}
